import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCurrentUser } from "../../UserProvider";
import { api, setAuthToken } from "../../utils/api";
import usePageTitle from "../../hooks/PageTitle";

export default function LoginTokenPage() {
  usePageTitle("Logging In");

  const navigate = useNavigate();
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useCurrentUser();

  useEffect(() => {
    const redirect = searchParams.get("redirect") || "/jobs";

    const login = async () => {
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        const { data } = await api.post("/login_tokens/login", { token });

        // store JWTs
        setAuthToken(data);

        // load user
        await refreshUser();

        // redirect
        navigate(redirect, { replace: true });

      } catch (err) {
        console.error(err);

        // fallback
        navigate("/login", { replace: true });
      }
    };

    login();
  }, [token, searchParams, navigate, refreshUser]);

  return (
    <div className="__login-token-page">
      <h1 className="form__title">Logging you in...</h1>
      <p className="form__subtitle">
        Please wait while we securely log you in.
      </p>
    </div>
  );
}
